export const versions = [
  "v1.0.0",
  "v1.1.0",
  "v1.2.0",
  "v1.3.0",
  "v1.4.0",
  "v1.5.0",
  "v1.6.0",
  "v1.7.0",
  "v1.8.0",
  "v1.9.0.",
  "v1.10.0",
  "v1.11.0",
  "v1.12.0",
  "v1.13.0",
  "v1.14.0",
  "v1.15.0",
  "v1.16.0",
  "v1.17.0",
  "v1.18.0",
  "v1.19.0",
  "v2.0.0",
  "v2.1.0",
  "v2.2.0",
];
